import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  agronomistDetails: {},
};

export const agronomistSlice = createSlice({
  name: "agronomist",
  initialState,
  reducers: {
    addAgronomistDetails: (state, action) => {
      state.agronomistDetails = action.payload;
    },

    removeAgronomistDetails: (state) => {
      state.agronomistDetails = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { addAgronomistDetails, removeAgronomistDetails } =
  agronomistSlice.actions;

export default agronomistSlice.reducer;
